module.exports = __webpack_public_path__ + "img/camera.dfd2b2b4.svg";